import { Box, Container, Grid, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Tooltip, Button } from "@mui/material";
import { Add, Create as CreateIcon, Delete as DeleteIcon } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AHMIS, { API_URL } from "../../../../api/api";
import AddAlertMessage from "../../../../components/alert/Alert";
import CustomModal from "../../../../components/modal/CustomModal";
import CustomSelect from "../../../../components/custom-react-select/CustomReactSelect";
import DeleteRegisterRecordConformation from "../../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation";
import { ERROR, REQUIRED_FIELD, SOMETHING_WENT_WRONG, SUCCESS } from "../../../../utils/constants";
import { LAB_TEST_CATEGORIES } from "../../../../utils/constants/forms";
import styles from "./style";
import { AppMisc } from "../../../../misc/appMisc";

export default function LabSewaItem() {
  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();

  useEffect(() => {
    getLabSewaItems();
  }, []);

  const getLabSewaItems = () => {
    AHMIS.get(API_URL.labsewaItem)
      .then(response => {
        if (response.data.type === SUCCESS) {
          setTableData(response.data.data?.objectList || response.data.data || []);
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const handleCustomSelectChange = (name, value) => {
    setValue(name, value);
  };

  const onSubmit = (data) => {
    if (modalDefaultValues.id) {
      data.id = modalDefaultValues.id;
    }
    AHMIS.post(API_URL.labsewaItem, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          reset();
          setShowModal(false);
          setModalDefaultValues({});
          getLabSewaItems();
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = (deleteReason) => {
    AHMIS.delete(`${API_URL.labsewaItem}/${deleteId}?deleteReason=${deleteReason || "deleted"}`)
      .then(response => {
        if (response.data.type === SUCCESS) {
          getLabSewaItems();
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const handleEdit = (item) => {
    AHMIS.get(`${API_URL.labsewaItem}/${item.id}`)
      .then(response => {
        if (response.data.type === SUCCESS) {
          setModalDefaultValues(response.data.data);
          setShowModal(true);
          if (response.data.data.reportTemplate) {
            setValue("reportTemplate", response.data.data.reportTemplate);
          }
          setValue("sewaName", response.data.data.sewaName);
        } else {
          AddAlertMessage({ type: response.data.type, message: response.data.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const closeModal = () => {
    reset();
    setShowModal(false);
    setModalDefaultValues({});
  };

  return (
    <Container maxWidth="xl" disableGutters style={{ padding: "8px" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} borderBottom={1} pb={1}>
        <Typography variant="h6">प्रयोगशाला सेवाहरू</Typography>
        <Button variant="contained" color="primary" startIcon={<Add />} onClick={() => setShowModal(true)}>नयाँ रेकर्ड थप्नुहोस्</Button>
      </Box>
      <TableContainer classes={{ root: "fixed-head-table-container" }}  >
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="lab sewa Register">
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell>क्र.सं.</TableCell>
              <TableCell>सेवा नाम</TableCell>
              <TableCell>रिपोर्ट टेम्पलेट</TableCell>
              <TableCell>कार्य</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            {Array.isArray(tableData) && tableData.map((item, index) => (
              <TableRow key={item.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.sewaName}</TableCell>
                <TableCell>{AppMisc.findLabelFromValue(LAB_TEST_CATEGORIES, item.reportTemplate)}</TableCell>
                <TableCell>
                  <Tooltip title="सम्पादन गर्नुहोस्">
                    <IconButton size="small" onClick={() => handleEdit(item)}>
                      <CreateIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="हटाउनुहोस्">
                    <IconButton size="small" onClick={() => handleDeleteClick(item.id)}>
                      <DeleteIcon fontSize="small" color="secondary" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomModal
        title={modalDefaultValues.id ? "सेवा सम्पादन गर्नुहोस्" : "नयाँ सेवा थप्नुहोस्"}
        onModalSubmit={handleSubmit(onSubmit)}
        showModal={showModal}
        onModalClose={closeModal}
        maxWidth="lg"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="सेवा नाम"
              size="small"
              variant="outlined"
              name="sewaName"
              defaultValue={modalDefaultValues.sewaName}
              {...register("sewaName", { required: true })}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            {errors.sewaName && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12}>
            <CustomSelect
              label="रिपोर्ट टेम्पलेट"
              name="reportTemplate"
              size="small"
              options={LAB_TEST_CATEGORIES}
              defaultValue={modalDefaultValues.reportTemplate}
              onChange={handleCustomSelectChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </CustomModal>
      <DeleteRegisterRecordConformation
        showDeleteModal={showDeleteModal}
        closeDeleteModel={() => { setShowDeleteModal(false); setDeleteId(null); }}
        deleteRecord={handleDeleteConfirm}
      />
    </Container>
  );
}
